module.exports = __webpack_public_path__ + "static/media/dev-1.56dc1614.png";